// extracted by mini-css-extract-plugin
export default {"noScrollContainer":"embedMode__noScrollContainer__VgVwH","active":"embedMode__active__T63gg"};